import { render } from "./prospective_applicant.html?vue&type=template&id=057acf08&scoped=true&external"
import script from "./prospective_applicant.js?vue&type=script&lang=js&external"
export * from "./prospective_applicant.js?vue&type=script&lang=js&external"

import "./ProspectiveApplicant.vue?vue&type=style&index=0&id=057acf08&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057acf08"]])

export default __exports__